import {Component} from '@angular/core';

@Component({
  selector: 'app-groupset-dialog',
  templateUrl: './groupset-dialog.component.html',
  styleUrls: ['./groupset-dialog.component.scss']
})
export class GroupsetDialogComponent {
}
